<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-form :inline="true" :model="orderInfo" :rules="rules" ref="orderInfo" label-width="150px" class="orderinfo-form" size="mini">
                    <el-row>
                        <el-form-item label="订单编号" prop="orderCode">
                            <el-input v-model="orderInfo.orderCode" :disabled="isDisabled" placeholder="订单编号自动生成"></el-input>
                        </el-form-item>
                        <el-form-item label="载体名称" prop="carrierId">
                            <el-tooltip class="item" effect="dark" :content="orderTip.carrierName" placement="top-start" :open-delay="delaytime" >
                                <el-select v-model="orderInfo.carrierId" clearable filterable placeholder="请选择载体名称" @change="carrierChange">
                                    <el-option
                                    v-for="item in carriers"
                                    :key="item.id"
                                    :label="item.carrierName"
                                    :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="载体详情">
                            <el-button size="mini" type="success" @click="toCarrierDetail">查看载体详情</el-button>
                        </el-form-item>
                        <el-form-item label="样品编号" prop="sampleNum">
                            <el-tooltip class="item" effect="dark" :content="orderTip.sampleNum" placement="top-start" :open-delay="delaytime">
                                <el-input v-model="orderInfo.sampleNum" minlength="5" maxlength="5" show-word-limit placeholder="请输入5个字符的字母和数字"></el-input>
                            </el-tooltip>
                        </el-form-item>
                        <el-tooltip :content="experimentNumContent" placement="top">
                            <el-form-item label="实验编号" prop="experimentNum">
                                <el-input v-model="orderInfo.experimentNum" :disabled="isExperimentNumDisabled" placeholder="实验编号自动生成"></el-input>
                            </el-form-item>
                        </el-tooltip>
                        <el-form-item label="插入片段" prop="insertFragment">
                            <el-tooltip class="item" effect="dark" :content="orderTip.insertFragment" placement="top-start" :open-delay="delaytime">
                                <el-input v-model="orderInfo.insertFragment" placeholder="插入片段"></el-input>
                            </el-tooltip>
                            
                        </el-form-item>
                        <el-form-item label="是否已经纯化" prop="isPurifying">
                            <el-tooltip class="item" effect="dark" :content="orderTip.isPurifying" placement="top-start" :open-delay="delaytime">
                                <el-select v-model="orderInfo.isPurifying" clearable filterable placeholder="请选择" >
                                    <el-option
                                    v-for="item in yesOrNo"
                                    :key="item.dictCode"
                                    :label="item.dictDesc"
                                    :value="item.dictCode">
                                    </el-option>
                                </el-select>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="上游位点" prop="upstreamSite">
                            <el-tooltip class="item" effect="dark" :content="orderTip.upstreamSite" placement="top-start" :open-delay="delaytime">
                                <el-select v-model="orderInfo.upstreamSite" clearable filterable placeholder="请先选择载体">
                                    <el-option
                                    v-for="item in upstreamSites"
                                    :key="item.id"
                                    :label="item.cleavageSiteName"
                                    :value="item.cleavageSiteName">
                                    </el-option>
                                </el-select>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="下游位点" prop="downstreamSite">
                            <el-tooltip class="item" effect="dark" :content="orderTip.downstreamSite" placement="top-start" :open-delay="delaytime">
                                <el-select v-model="orderInfo.downstreamSite" clearable filterable placeholder="请先选择载体">
                                    <el-option
                                    v-for="item in downstreamSites"
                                    :key="item.id"
                                    :label="item.cleavageSiteName"
                                    :value="item.cleavageSiteName">
                                    </el-option>
                                </el-select>
                            </el-tooltip>
                        </el-form-item>
                        <!-- <el-form-item label="是否测序" prop="isSequencing">
                            <el-tooltip class="item" effect="dark" :content="orderTip.isSequencing" placement="top-start" :open-delay="delaytime">
                                <el-select v-model="orderInfo.isSequencing" clearable filterable placeholder="请选择" @change="isSequencingChange">
                                    <el-option
                                    v-for="item in yesOrNo"
                                    :key="item.dictCode"
                                    :label="item.dictDesc"
                                    :value="item.dictCode">
                                    </el-option>
                                </el-select>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="送测公司" prop="sequenceCompany" v-if="isShowSequenceCompany">
                            <el-tooltip class="item" effect="dark" :content="orderTip.sequenceCompany" placement="top-start" :open-delay="delaytime">
                                <el-select v-model="orderInfo.sequenceCompany" clearable filterable placeholder="请选送测公司">
                                    <el-option
                                    v-for="item in seqCompanys"
                                    :key="item.companyName"
                                    :label="item.companyName"
                                    :value="item.companyName">
                                    </el-option>
                                </el-select>
                            </el-tooltip>
                        </el-form-item> -->
                        <el-form-item label="阳性克隆数" prop="positiveCloneNum">
                            <el-tooltip class="item" effect="dark" :content="orderTip.positiveCloneNum" placement="top-start" :open-delay="delaytime">
                                <el-input-number placeholder="请输入阳性克隆数" v-model="orderInfo.positiveCloneNum" controls-position="right" :min="0" :precision="0"></el-input-number>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="测序引物名称" prop="sequencePrimerName">
                            <el-tooltip class="item" effect="dark" :content="orderTip.sequencePrimerName" placement="top-start" :open-delay="delaytime">
                                <el-input v-model="orderInfo.sequencePrimerName" placeholder="测序引物名称"></el-input>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="订单状态" prop="orderStatus" v-if="isHasAuthority">
                            <el-select v-model="orderInfo.orderStatus" clearable filterable placeholder="请选择">
                                <el-option
                                v-for="item in orderStatuses"
                                :key="item.dictCode"
                                :label="item.dictDesc"
                                :value="item.dictCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        
                        <el-form-item label="加测引物碱基数" prop="companyKtr" v-if="isHasAuthority2">
                            <el-input-number placeholder="请输入加测引物碱基数" v-model="orderInfo.companyKtr" controls-position="right" :min="0" :precision="0"></el-input-number>
                        </el-form-item>
                        <el-form-item label="测序反应数" prop="companyJkr" v-if="isHasAuthority2">
                            <el-input-number placeholder="请输入测序反应数" v-model="orderInfo.companyJkr" controls-position="right" :min="0" :precision="0"></el-input-number>
                        </el-form-item>
                        <el-form-item label="生工" prop="companySg" v-if="isHasAuthority1">
                            <el-input-number placeholder="请输入生工测序反应数" v-model="orderInfo.companySg" controls-position="right" :min="0" :precision="0"></el-input-number>
                        </el-form-item>
                        <el-form-item label="擎科" prop="companyQk" v-if="isHasAuthority1">
                            <el-input-number placeholder="请输入擎科测序反应数" v-model="orderInfo.companyQk" controls-position="right" :min="0" :precision="0"></el-input-number>
                        </el-form-item>
                        <el-form-item label="合测" prop="companyHc" v-if="isHasAuthority1">
                            <el-input-number placeholder="请输入合测测序反应数" v-model="orderInfo.companyHc" controls-position="right" :min="0" :precision="0"></el-input-number>
                        </el-form-item>
                        <el-form-item label="测序结果" prop="resultFileName" v-if="isHasAuthority1">
                            <el-input v-model="orderInfo.resultFileName" placeholder="测序结果" readonly>
                                <el-button  slot="append"  @click="toUpload" style="background-color:#67C23A;color:#FFF;border-color:#67C23A;">上传</el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="订单金额" prop="orderAmount" v-if="isHasAuthority1">
                            <el-input-number placeholder="请输入订单金额" v-model="orderInfo.orderAmount" controls-position="right" :min="0" :precision="2"></el-input-number>
                        </el-form-item>
                        <el-form-item label="支付意愿确认" prop="payWillingness" v-if="isHasAuthority">
                            <el-select v-model="orderInfo.payWillingness" filterable clearable placeholder="请选择" >
                                <el-option
                                v-for="item in payWillingnesses"
                                :key="item.dictCode"
                                :label="item.dictDesc"
                                :value="item.dictCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="客户结算金额" prop="customSettlementAmount" v-if="isHasAuthority">
                            <el-input-number placeholder="请输入客户结算金额" v-model="orderInfo.customSettlementAmount" controls-position="right" :min="0" :precision="2"></el-input-number>
                        </el-form-item>
                        <el-form-item label="代理结算金额" prop="agentSettlementAmount" v-if="isHasAuthority">
                            <el-input-number placeholder="请输入代理结算金额" v-model="orderInfo.agentSettlementAmount" controls-position="right" :min="0" :precision="2"></el-input-number>
                        </el-form-item>
                        <el-form-item label="归属责任客户" prop="attributableCustomer" v-if="isHasAuthority">
                            <el-input v-model="orderInfo.attributableCustomer" placeholder="归属责任客户"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="插入片段序列" prop="insertFragmentSeq">
                            <el-tooltip class="item" effect="dark" :content="orderTip.insertFragmentSeq" placement="top-start" :open-delay="delaytime">
                                <el-input style="display:block;width: 960px" type="textarea" :rows="10" maxlength="10000" show-word-limit v-model="orderInfo.insertFragmentSeq"></el-input>
                            </el-tooltip>
                        </el-form-item>
                    </el-row>
                    <el-row type="flex" style="justify-content: right;" class="button-row">
                        <el-button v-if="isHasSaveBtn" size="mini" type="primary" @click="save('orderInfo')">保存</el-button>
                        <el-button v-if="isHasSubBtn" size="mini" type="primary" @click="submitForm('orderInfo')">提交</el-button>
                        <el-button size="mini" @click="cancel">取消</el-button>
                    </el-row>
                </el-form>
            </el-col>
        </el-row>

        <el-dialog title="用户列表" :visible.sync="userDialogVisible" append-to-body>
            <UserSearch :key="timer" :roleCodeProp="roleCode"></UserSearch>
        </el-dialog>

        <el-dialog title="提成比例" :visible.sync="percentageDialogVisible" append-to-body>
            <PercentageSearch :percentageId="orderInfo.percentageId"></PercentageSearch>
        </el-dialog>
        <el-dialog title="测序结果上传" :visible.sync="uploadDialogVisible" append-to-body>
            
            <el-row type="flex" style="justify-content: center;">
                <el-upload
                class="upload-demo"
                drag
                action="/api/order/uploadFile"
                multiple
                :limit="1"
                :show-file-list="false"
                :on-remove="handleRemove"
                :on-exceed="handleExceed"
                :file-list="fileList"
                :before-upload="beforeAvatarUpload"
                :on-success="uploadSuccess">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传zip/rar文件</div>
                </el-upload>
            </el-row>
            <el-row type="flex" style="justify-content: right;">
                <el-button size="mini" type="primary" @click="cancelUpload()">取消</el-button>
                <el-button size="mini" type="primary" @click="submitUpload()">确定</el-button>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>

import UserSearch from '../user/UserSearch.vue';
import PercentageSearch from '../percentage/PercentageSearch.vue'

export default {
    name: "OrderInfoUpdate",
    props: ["orderInfoProp"],
    components: {
        UserSearch,
        PercentageSearch
    },
    data() {
        return {
            orderInfo: {
            },
            rules: {
                carrierId: [
                    { required: true, message: "请选择载体名称", trigger: "change" },
                ],
                sampleNum: [
                    { required: true, message: "请输入样品编号", trigger: "blur" },
                    { min: 5, max: 5, message: "样品编号长度为5个字符", trigger: "blur" }
                ],
                insertFragment: [
                    { required: true, message: "请输入插入片段", trigger: "blur" }
                ],
                isPurifying: [
                    { required: true, message: "请选择是否已经纯化", trigger: "change" },
                ],
                upstreamSite: [
                    { required: true, message: "请选择上游位点", trigger: "change" }
                ],
                downstreamSite: [
                    { required: true, message: "请选择下游位点", trigger: "change" },
                ],
                isSequencing: [
                    { required: true, message: "请选择是否测序", trigger: "change" }
                ],
                positiveCloneNum: [
                    { required: true, message: "请输入阳性克隆数", trigger: "blur" },
                ],
                sequencePrimerName: [
                    { required: false, message: "请输入测序引物名称", trigger: "blur" }
                ],
                insertFragmentSeq: [
                    { required: true, message: "请输入插入片段序列", trigger: "blur" }
                ],
                sequenceCompany: [
                    { required: true, message: "请输入测序公司", trigger: "blur" }
                ],
            },
            isDisabled: true,
            deliverys: [],
            isReceipts: [],
            isCommissions: [],
            confirmationReviews: [],
            userDialogVisible: false,
            salerButton: false,
            receiverButton: false,
            operatorButton: false,
            currentDialog: "",
            percentageDialogVisible: false,
            experimentNumDisabled: false,
            isTermRequired: false,
            restaurants: [],
            salerName:"",
            receiverName:"",
            operatorName:"",
            isConfirmationReviewDisabled: false,
            isHasAuthority: false,
            isHasAuthority1: false,
            isHasAuthority2: false,
            isShowDirector: false,
            roleCode:"COMMISSION_HOLDER",
            timer:'',
            experimentNumTooltipDisabled: true,
            experimentNumContent:'',
            quotationAmountTooltipDisabled: true,
            quotationAmountContent: '',
            yesOrNo: [],
            orderStatuses: [],
            payWillingnesses: [],
            carriers: [],
            downstreamSites: [],
            upstreamSites: [],
            uploadDialogVisible: false,
            uploadData: {},
            fileList: [],
            isHasSaveBtn: false,
            orderTip: {},
            seqCompanys: [],
            isShowSequenceCompany: false,
            isHasSubBtn: true,
            isExperimentNumDisabled: true,
            delaytime:1000
        };
    },
    methods: {
        submitForm(formName) {
            if(this.user.userStatus === 'SUSPEND') {
                this.$message.error("无法提交！请联系工作人员沟通详情");
                return;
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(!this.orderInfo.orderStatus) {
                        this.$set(this.orderInfo, "orderStatus", "SUBMIT");
                    }else if(this.orderInfo.orderStatus === 'DRAFT') {
                        this.$set(this.orderInfo, "orderStatus", "SUBMIT");
                    }
                    this.$axios.post("/order/save", this.orderInfo).then(res => {
                        if (res.data.status === "success") {
                            this.$message({
                                message: "提交成功！",
                                type: "success"
                            });
                            this.$bus.$emit(this.GlobeConstant.orderinfoupdate_to_orderinfo_close);
                        } else {
                            this.$message.error(res.data.message);
                        }
                    }, error => {
                        this.$message.error(error.message);
                    });
                } else {
                    return false;
                }
            });
        },
        cancel() {
            this.$bus.$emit(this.GlobeConstant.orderinfoupdate_to_orderinfo_close);
        },
        queryDicts(dictType) {
            let condition = {value:dictType};
            this.$axios.post("/dictionary/findByDictType",condition).then(
                res=>{
                    if(res.data.status === "success"){
                        if(dictType === 'ORDER_STATUS') {
                            this.orderStatuses = res.data.result;
                        } else if(dictType === 'YES_NO') {
                            this.yesOrNo = res.data.result;
                        }else if(dictType === 'PAY_WILLINGNESS') {
                            this.payWillingnesses = res.data.result;
                        }
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        queryCarriers() {
            this.$axios.post("/carrierLibrary/findAll").then(
                res=>{
                    if(res.data.status === "success"){
                        this.carriers = res.data.result;
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        searchUser(dialog) {
            if(dialog === "saler") {
                this.roleCode = 'COMMISSION_HOLDER';
            }else if(dialog === "receiver") {
                this.roleCode = 'COMMISSION_HOLDER';
            }else if(dialog === "operator") {
                this.roleCode = 'COMMISSION_HOLDER';
            } else if(dialog=== "director") {
                this.roleCode = 'DIRECTOR';
            }
            this.currentDialog = dialog;
            this.userDialogVisible = true;
            this.timer = new Date().getTime();
            
        },
        handleClear(dialog) {
            if(dialog === "saler") {
                this.$confirm('您确认删除此销售?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$set(this.orderInfo, "salerName", "");
                    this.$set(this.orderInfo, "saler", "");
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            }else if(dialog === "receiver") {
                this.$confirm('您确认删除此接单?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    // this.orderInfo.receiverName = "";
                    // this.orderInfo.reciver = "";
                    this.$set(this.orderInfo, "receiverName", "");
                    this.$set(this.orderInfo, "receiver", "");
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            }else if(dialog === "operator") {
                this.$confirm('您确认删除此操作?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.orderInfo.operatorName = "";
                    this.orderInfo.operator = "";
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            } else if(dialog=== "auxiliary") {
                this.$confirm('您确认删除此辅助?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.orderInfo.auxiliaryName = "";
                    this.orderInfo.auxiliary = "";
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            }
        },
        setUserInfo(data) {
            if(this.currentDialog === "saler") {
                this.orderInfo.saler = data.userId;
                this.salerName = data.userRealName;
            }else if(this.currentDialog === "receiver") {
                this.orderInfo.receiver = data.userId;
                this.receiverName = data.userRealName;
            }else if(this.currentDialog === "operator") {
                this.orderInfo.operator = data.userId;
                this.operatorName = data.userRealName;
            } else if(this.currentDialog === "director") {
                this.orderInfo.director = data.userId;
                this.directorName = data.userRealName;
            }
            //this.updateName();
            this.userDialogVisible = false;
        },
        searchPercentage() {
            this.percentageDialogVisible = true;
        },
        setPercentage(data) {
            this.orderInfo.percentageId = data.percentageId;
            //this.orderInfo.percentageName = data.percentageName;
            this.$set(this.orderInfo, 'percentageName', data.percentageName)
            // this.orderInfo.totalRatio = data.totalRatio;
            // this.orderInfo.salerRatio = data.salerRatio;
            // this.orderInfo.receiverRatio = data.receiverRatio;
            // this.orderInfo.operatorRatio = data.operatorRatio;
            // this.orderInfo.directorRatio = data.directorRatio;
            //this.updateName();
            this.percentageDialogVisible = false;
        },
        querySearch(queryString, cb) {
            var restaurants = this.restaurants;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (restaurant) => {
            return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        loadSettlementAmount() {
            return [
                { "value": "失败" },
                { "value": "撤单" },
                { "value": "纠错" },
                { "value": "免费" }
            ];
        },
        closePercentageSearch() {
            this.percentageDialogVisible = false;
        },
        carrierChange(){
            this.queryCleavageSite();
            this.$set(this.orderInfo, "upstreamSiteId", "");
            this.$set(this.orderInfo, "downstreamSiteId", "");
            if(this.orderInfo.carrierId) {
                let currentCarrier = this.carriers.find((item)=>{//这里的userRoleList就是上面遍历的数据源
                    return item.id === this.orderInfo.carrierId;//筛选出匹配数据
                });
                this.orderInfo.carrierUrl = currentCarrier.carrierUrl;
            }
        },
        toCarrierDetail() {
            if(this.orderInfo.carrierUrl) {
                window.open(this.orderInfo.carrierUrl);
            } else {
                this.$message.error("载体详情不存在！");
            }
        },
        queryCleavageSite() {
            if(!this.orderInfo.carrierId) {
                return;
            }
            var condition = {
                'id':this.orderInfo.carrierId
            }
            this.$axios.post("/cleavageSite/findByCarrierId",condition).then(
                res=>{
                    if(res.data.status === "success"){
                        this.upstreamSites = res.data.result.upCleavageSiteList;
                        this.downstreamSites = res.data.result.downCleavageSiteList;
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        save(){
            this.orderInfo.orderStatus = "DRAFT";
            this.$axios.post("/order/save", this.orderInfo).then(res => {
                if (res.data.status === "success") {
                    this.$message({
                        message: "保存成功！",
                        type: "success"
                    });
                    this.$bus.$emit(this.GlobeConstant.orderinfoupdate_to_orderinfo_close);
                } else {
                    this.$message.error(res.data.message);
                }
            }, error => {
                this.$message.error(error.message);
            });
                
        },
        toUpload() {
            this.uploadDialogVisible = true;
            this.fileList = [];
        },
        cancelUpload() {
            if(this.uploadData.resultFilePath) {
                this.handleRemove();
            }
            this.fileList = [];
            this.uploadDialogVisible = false;
        },
        submitUpload() {
            if(!this.uploadData.resultFilePath) {
                this.$message.error("请先上传文件，再确定！");
            } else {
                this.$set(this.orderInfo, "resultFilePath", this.uploadData.resultFilePath);
                this.$set(this.orderInfo, "resultFileName", this.uploadData.resultFileName);
                this.$axios.post("/order/updateUploadFile", this.orderInfo).then(res => {
                    if (res.data.status === "success") {
                        this.$message.info("上传完成！");
                        this.uploadDialogVisible = false;
                    } else {
                        this.$message.error(res.data.message);
                    }
                }, error => {
                    this.$message.error(error.message);
                });
            }
        },
        handleExceed() {
            this.$message.warning(`当前限制选择 1 个文件`);
        },
        handleRemove() {
            if(!this.uploadData.resultFilePath) {
                return;
            }
            var param = {
                value : this.uploadData.resultFilePath
            }
            this.$axios.post("/order/delUploadFile", param).then(res => {
                if (res.data.status === "success") {
                    this.uploadData = {};
                } else {
                    this.$message.error(res.data.message);
                }
            }, error => {
                this.$message.error(error.message);
            });
        },
        uploadSuccess(res) {
            if (res.status === "success") {
                this.uploadData = res.result;
            } else {
                this.$message.error(res.message);
            }
        },
        queryOrderTip() {
            this.$axios.post("/orderTip/find").then(
                res=>{
                    if(res.data.status === "success"){
                        this.orderTip = res.data.result;
                    } else {
                        this.$message.error(res.data.message);
                    }
                    this.loading = false;
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        querySeqCompany() {
            this.$axios.post("/seqCompany/findList").then(
                res=>{
                    if(res.data.status === "success"){
                        this.seqCompanys = res.data.result;
                    } else {
                        this.$message.error(res.data.message);
                    }
                    this.loading = false;
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        isSequencingChange() {
            if(this.orderInfo.isSequencing === 'Y') {
                this.isShowSequenceCompany = true;
            }else {
                this.isShowSequenceCompany = false;
            }

            //this.$set(this.orderInfo, "upstreamSiteId", "");
            //this.$set(this.orderInfo, "downstreamSiteId", "");
        },
        beforeAvatarUpload(file) {
            let fileName = file.name;
            let pos = fileName.lastIndexOf(".");
            let lastName = fileName.substring(pos, fileName.length);
            if (lastName.toLowerCase() !== ".rar" && lastName.toLowerCase() !== ".zip") {
                this.$message.error("文件必须为zip/rar类型");
                return false;
                
            }
            return true;
        },
        queryFieldHis() {
            if(this.orderInfo.orderId) {
                let param = {
                    value: this.orderInfo.orderId
                }
                this.$axios.post("/orderFieldHis/findByOrderId",param).then(
                    res=>{
                        if(res.data.status === "success"){
                            if(res.data.result) {
                                this.experimentNumContent = "历史实验编号：" + res.data.result;
                            }
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            }
        }
    },
    created() {
        this.orderInfo = this.orderInfoProp;
        //如果是新增，那么是否已经存化默认为否
        if(!this.orderInfo.isPurifying) {
            //this.orderInfo.isPurifying = 'N';
        }
        //this.updateName();
        this.queryDicts("ORDER_STATUS");
        this.queryDicts("YES_NO");
        this.queryDicts("PAY_WILLINGNESS");
        this.queryCarriers();
        this.queryCleavageSite('UP');
        this.queryCleavageSite('DOWN');
        if(this.orderInfo.orderInfoId) {
            this.experimentNumDisabled = true;
        }
        if(this.orderInfo.confirmationReview === "REVIEWED") {
            this.isConfirmationReviewDisabled = true;
        }
        this.queryOrderTip();
        this.querySeqCompany();
        this.isSequencingChange();
    },
    mounted() {
        this.$bus.$on(this.GlobeConstant.usersearch_to_orderinfoupdate, this.setUserInfo);
        this.$bus.$on(this.GlobeConstant.percentagesearch_to_orderinfoupdate, this.setPercentage);
        this.$bus.$on(this.GlobeConstant.percentagesearch_to_orderinfoupdate_close, this.closePercentageSearch);
        this.restaurants = this.loadSettlementAmount();
        this.user = JSON.parse(window.localStorage.getItem("user"));
        if(this.user.roleCode === 'ADMIN' || this.user.roleCode === 'SUPER') {
            this.isHasAuthority = true;
            this.isHasAuthority1 = true;
            this.isHasAuthority2 = true;
            this.isExperimentNumDisabled = false;
            if(this.orderInfo.isDirectorCreate !== "Y") {
                this.isShowDirector = true;
            }
        }else if(this.user.roleCode === 'AGENT' || this.user.roleCode === 'RESPONSIBLE' || this.user.roleCode === 'ORDINARY'){
            if(this.user.roleCode === 'RESPONSIBLE') {
                this.isHasAuthority1 = true;
                this.isHasAuthority2 = true;
            }
            if(this.user.roleCode === 'ORDINARY') {
                this.rules.sequencePrimerName = [];
            }
            if(this.orderInfo.orderStatus) {
                if(this.orderInfo.orderStatus === 'DRAFT') {
                    this.isHasSaveBtn = true;
                }
            }else {
                this.isHasSaveBtn = true;
            }
        } else {
            if(this.orderInfo.orderStatus) {
                if(this.orderInfo.orderStatus === 'DRAFT') {
                    this.isHasSaveBtn = true;
                }
            } else {
                this.isHasSaveBtn = true;
            }
            this.isHasSubBtn = false;
        }
        this.queryFieldHis();
    },
    beforeDestroy() {
        this.$bus.$off(this.GlobeConstant.usersearch_to_orderinfoupdate);
        this.$bus.$off(this.GlobeConstant.percentagesearch_to_orderinfoupdate);
        this.$bus.$on(this.GlobeConstant.percentagesearch_to_orderinfoupdate_close);
    }
}


</script>

<style scoped>

   .orderinfo-form {
       margin: 20px 30px 20px 20px;
   }

   .el-select {
        width: 220px;
    }

    .el-input {
        width: 220px;
    }
    .el-date-picker {
        width: 200px;
        background-color: green;
    }
    .el-cascader {
        width: 220px;
    }
    .el-input-number {
        width: 220px;
    }

    .button-row {
        display: flex;
        justify-content: right;
        border-top: solid 1px;
        
    }
    .button-row >.el-button {
        margin-top: 10px;
    }

</style>
